import { IWithContextProps, withContext } from '@tock/coretypes';
import { RouteComponentProps } from 'react-router-dom';
import { Theme, css } from '@emotion/react';
import { purchaseHistorySortedSelector } from 'selectors/purchaseHistorySelector';
import AccountPageMobileHeading from 'components/account/AccountPageMobileHeading';
import BaseComponent from '@tock/shared/components/BaseComponent';
import ConsumerPanel from 'components/ConsumerPanel';
import TransactionHistory from 'components/account/TransactionHistory';
import connect, { DefaultConnectProps, StoreType } from '@tock/shared/utils/connect';

interface ConnectProps extends DefaultConnectProps {
  app: StoreType['app'];
  patron: StoreType['patron'];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  purchaseHistory: any[];
}
class TransactionsRoute extends BaseComponent<
  ConnectProps & RouteComponentProps & IWithContextProps
> {
  componentDidMount() {
    this.props.actions.navigation.set({
      hasLogo: true,
      hasBack: false,
    });
    this.props.actions.patron.fetchPurchaseHistory();
    this.props.actions.patron.fetchLegacyTransferHistory();
    this.props.actions.tockGiftCard.fetchGiftCardPurchaseHistory();
  }

  render() {
    const { purchaseHistory, patron } = this.props;
    return (
      <div className="Account-content">
        <AccountPageMobileHeading
          css={({ spacing }: Theme) => css`
            margin-left: ${spacing(2.25)}px;
          `}
        >
          Transactions
        </AccountPageMobileHeading>
        <ConsumerPanel isLoading={patron.numRequestsInProgress > 0}>
          <TransactionHistory history={purchaseHistory} />
        </ConsumerPanel>
      </div>
    );
  }
}

export default connect<RouteComponentProps, ConnectProps>(
  withContext(TransactionsRoute),
  (state: StoreType) => {
    return {
      app: state.app,
      patron: state.patron,
      purchaseHistory: purchaseHistorySortedSelector(state),
    };
  }
);
